// 受支持的语言与默认语言，集中管理以避免在 i18n / router / App / LanguageSwitcher 多处硬编码。
export const SUPPORTED_LOCALES = ['zh', 'en', 'ja', 'ko'];
export const DEFAULT_LOCALE = 'zh';

// 语言偏好检测：localStorage 保存 > 浏览器语言 > 默认语言。
// router.getUserPreferredLanguage 与 LanguageSwitcher 共用此实现，消除重复逻辑。
export function detectPreferredLocale() {
  const saved = localStorage.getItem('language');
  if (saved && SUPPORTED_LOCALES.includes(saved)) return saved;

  const browserLang = (navigator.language || '').toLowerCase();
  if (browserLang.startsWith('zh')) return 'zh';
  if (browserLang.startsWith('en')) return 'en';
  if (browserLang.startsWith('ja')) return 'ja';
  if (browserLang.startsWith('ko')) return 'ko';

  return DEFAULT_LOCALE;
}
